import { el } from "../components/dom.js";
import {
	authShell,
	authField,
	authInput,
	authButton,
	authMessage,
	authLinks,
	authLink,
} from "../components/auth-ui.js";
import { signIn } from "../db/auth.js";
import { localDataCounts, isMigrationDone, describeCounts } from "../db/migration.js";
import { navigate } from "../main.js";

export async function renderSignIn(root) {
	// Existing local-only collection on this device, surfaced as a welcome note
	// and used to route into the migration prompt after a successful sign-in.
	const counts = await localDataCounts();
	const hasLocal = counts.total > 0;

	const msg = authMessage();
	const email = authInput({ type: "email", autocomplete: "email", placeholder: "you@example.com" });
	const password = authInput({
		type: "password",
		autocomplete: "current-password",
		placeholder: "Your password",
	});

	const submit = authButton("Sign in", { primary: true });

	async function doSignIn() {
		msg.clear();
		const e = email.value.trim();
		const p = password.value;
		if (!e || !p) {
			msg.error("Enter your email and password.");
			return;
		}
		submit.disabled = true;
		try {
			await signIn({ email: e, password: p });
			navigate(hasLocal && !isMigrationDone() ? "/migrate" : "/");
		} catch (err) {
			msg.error(friendlySignInError(err));
			submit.disabled = false;
		}
	}

	submit.onclick = doSignIn;
	password.addEventListener("keydown", (ev) => {
		if (ev.key === "Enter") doSignIn();
	});

	const welcome = hasLocal
		? [
				el(
					"p.auth__lede",
					{},
					"MediaTracker now uses an account to sync your collection across devices.",
				),
				el(
					"p.auth-note",
					{},
					`The ${describeCounts(counts)} on this device will move into your account when you sign in.`,
				),
			]
		: [];

	root.append(
		authShell(
			{ title: "Welcome", titleEm: "back" },
			...welcome,
			msg.node,
			authField("Email", email),
			authField("Password", password),
			submit,
			authLinks(
				authLink("Forgot password?", () => navigate("/forgot-password")),
				authLink(
					["No account yet? ", el("strong", {}, "Sign up")],
					() => navigate("/sign-up"),
				),
			),
		),
	);
}

function friendlySignInError(err) {
	const m = (err?.message || "").toLowerCase();
	if (m.includes("invalid login")) return "Email or password is incorrect.";
	return err?.message || "Could not sign in. Try again.";
}
